export const ABSENCE_CANCELLED = 1
export const ABSENCE_PRESENT = 2
export const ABSENCE_ABSENT = 3

export const ABSENCE_STATUS = {
  [ABSENCE_CANCELLED]: "ABSENCE.STATUS.CANCEL",
  [ABSENCE_PRESENT]: "ABSENCE.STATUS.PRESENT",
  [ABSENCE_ABSENT]: "ABSENCE.STATUS.ABSENT",
}

export const ABSENCE_STATUS_COLOR = {
  [ABSENCE_CANCELLED]: "warning",
  [ABSENCE_PRESENT]: "success",
  [ABSENCE_ABSENT]: "danger"
}

export const absenceStatusUIHelper = (intl) =>
  Object.keys(ABSENCE_STATUS).map((key) => ({
    value: parseInt(key),
    label: intl.formatMessage({ id: ABSENCE_STATUS[key] }),
  }))
